import { createContext } from 'react';

export type AuthStatus = 'booting' | 'authed' | 'unauthed';

/** Delete now's outcome, shown on the signed-out screen: erased, or still finishing. */
export type SignedOutDeleted = 'erased' | 'erasing';

export interface SignOutOptions {
  sharedReturnTo?: string;
  deleted?: SignedOutDeleted;
}

export interface AuthContextValue {
  status: AuthStatus;
  /** A runtime expiry (a bearer 401 the refresh could not recover) — renders the interstitial. */
  sessionExpired: boolean;
  setAuthed: () => void;
  /**
   * Sign out and land on the signed-out screen; `deleted` adds Delete now's message there
   * (TMMAPP-0119 §E 26c), `sharedReturnTo` goes straight back to sign-in for an invitation.
   */
  signOut: (options?: SignOutOptions) => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
